<template>
  <VContainer class="useful-phone-numbers-page">
    <VRow>
      <VCol cols="12">
        <div class="useful-phone-numbers-page__content">
          <p>XtraPension is here to solve your problems and answer your Qs – Just ask us</p>
          <p>If you want to contact the UK yourself directly, here’s who to contact:</p>
          <p>
            HMRC National Insurance Enquiries <br />
            <i>Mon-Fri, 8am-6pm</i>
          </p>
          <table class="table-border">
            <tbody>
              <tr>
                <td class="text-center">
                  <div><b>Tel:</b> <a href="tel:+441912037010" target="_blank">+44 191 203 7010</a></div>
                  <div class="mt-2">Say “Voluntary Contributions“ when asked reason for your call.</div>
                </td>
                <td class="text-center">
                  <div>
                    <b>Webchat: </b>
                    <a href="https://www.tax.service.gov.uk/ask-hmrc/chat/national-insurance" target="_blank"
                      >Click here</a
                    >
                  </div>
                  <div class="mt-2"><i>Tip: Type “speak to advisor” twice to reach a person.</i></div>
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            HMRC control the National Insurance (NI) database which they share with DWP twice weekly. Call them if you
            have questions about:
          </p>
          <ul>
            <li>Number of years on your NI record</li>
            <li>Changing your address / name</li>
            <li>When your payment was received</li>
            <li>Have the years you bought been allocated to your NI record</li>
            <li>Whether or not you were “Contracted Out” (this usually means you also have a private/work pension)</li>
          </ul>
          <p>HMRC do NOT use email</p>
          <table class="table-border">
            <tbody>
              <tr>
                <td>
                  <div><b>HMRC Address for General Qs</b></div>
                  <div class="mt-2">
                    PT Operations North East England,<br />
                    HM Revenue and Customs, BX9 1AN, UK
                  </div>
                </td>
                <td>
                  <div>
                    <b>HMRC Address for Payment / Receipt Qs</b>
                  </div>
                  <div class="mt-2">
                    HM Revenue and Customs, <br />
                    National Insurance Contributions and <br />
                    Employer Office, BX5 5BD, UK
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <p><i>Note that BX9/BX5… are not real geographic locations but specialised "virtual" postcodes.</i></p>
          <p>
            DWP / Dept of Work & Pensions: <br />
            <i>Mon-Fri, 8am – 6pm</i>
          </p>
          <table class="table-border">
            <tbody>
              <tr>
                <td>
                  <div><b>If You’re UNDER State Pension Age</b></div>
                  <div class="mt-2">
                    <a href="tel:+441912183600" target="_blank">+44 191 218 3600</a>
                  </div>
                  <ul class="mt-2">
                    <li>Get a State Pension forecast by post</li>
                    <li>Clarify whether or not you need exactly 35 years to maximise your State Pension</li>
                  </ul>
                </td>
                <td>
                  <div>
                    <b>If You’re OVER / WITHIN 4 Mths of State Pension Age</b>
                  </div>
                  <div class="mt-2">
                    <a href="tel:+441912187777" target="_blank">+44 191 218 7777</a>
                  </div>
                  <ul class="mt-2">
                    <li>Start a Claim for your Pension</li>
                    <li>Get advice re deferring</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            DWP accept general enquiry emails:
            <a href="mailto:tvp.internationalqueries@dwp.gov.uk" target="_blank">tvp.internationalqueries@dwp.gov.uk</a>
            <br />
            <a href="https://www.gov.uk/state-pension-age/y/age" target="_blank"
              >Double-Check your State Pension Age here</a
            >
          </p>
          <p><b>IRELAND</b></p>
          <table class="table-border">
            <tbody>
              <tr>
                <td>
                  <div>
                    <b>To Get A PRSI Contributions Statement</b> <br />
                    <i>(Always check this for errors!)</i>
                  </div>
                  <div class="mt-2">
                    <i>0818 690 690 Option 4</i>
                  </div>
                  <div class="mt-2">
                    <i>Or get from MyWelfare.ie - <a href="http://xpen.uk/socins" target="_blank">See how</a></i>
                  </div>
                </td>
                <td>
                  <div>
                    <b>Irish State Pension Qs:</b> 0818 200 400 <br />
                    <i>Mon-Fri 9am – 5pm</i>
                  </div>
                  <div class="mt-2">
                    <b>Citizens Information</b> - 0818 07 4000 <br />
                    <i>Mon-Fri 9am – 8pm</i>
                  </div>
                  <div class="mt-2">
                    To check possible tax issues, overall <br />
                    entitlements, PRSI credit-issues etc
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <p><b>AUSTRALIA – Qs re Age Pension etc</b></p>
          <p>
            Call Centrelink : 132 300 <br />
            <i>Mon-Fri 8am-5pm</i>
          </p>
          <p>
            Say “Financial Information Service“ <br />
            when asked reason for your call.
          </p>
        </div>
      </VCol>
    </VRow>
  </VContainer>
</template>
<script>
import { mapActions } from 'vuex';
// Utils
export default {
  name: 'UsefulPhoneNumbersPage',
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    ...mapActions('main', ['showSnackbar'])
  }
};
</script>
